import { render, staticRenderFns } from "./addTemplateView.vue?vue&type=template&id=32ba0210&scoped=true"
import script from "./addTemplateView.vue?vue&type=script&lang=js"
export * from "./addTemplateView.vue?vue&type=script&lang=js"
import style0 from "./addTemplateView.vue?vue&type=style&index=0&id=32ba0210&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ba0210",
  null
  
)

export default component.exports